module.exports = __webpack_public_path__ + "static/media/support1.1ea73b38.png";